import React from "react";
import NotFoundPage from "../articulos/404";
import Banner from "../../imgs/bg_buniversity.jpg";
const Article404 = () => {
    return <NotFoundPage productTitle="Balanz University" banner={Banner} />
}

export default Article404;